import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@utils/api";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { onboardingQKeys } from "@hooks/queries/onboarding/queryKeys";

export const useSignContract = () => {
  const handleErrors = useQueryErrorHandling();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (signatureData: { signature_name: string }) => 
      api.post(`onboarding/session/me/sign`, signatureData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: onboardingQKeys.session() });
    },
    onError: (res: any) => {
      console.error("[From Sign Contract]", res);
      queryClient.invalidateQueries({ queryKey: onboardingQKeys.session() });
      handleErrors(res, "mutation");
    },
  });
};
